import * as React from 'react';
import { useState } from 'react';
import { assert } from '../../lib/utils';
import { offset, size, position } from './type';

export default function ({path, onDrag, onWheel}: {
    path: string,
    onDrag: (offset: offset) => void,
    onWheel?: (e: WheelEvent) => void,
}) {
    const [size, setSize] = useState<size | null>(null);

    const style: React.CSSProperties = {
        width: size ? `${size.width}px` : '0px',
        height: size ? `${size.height}px` : '0px',
    }

    return (
    <iframe src={path} style={style} scrolling='no'
        onLoad={e => {
            const doc = e.currentTarget.contentDocument;
            assert(doc !== null, 'doc is null');
            const size: size = {
                width: doc.querySelector('html')!.scrollWidth,
                height: doc.querySelector('html')!.scrollHeight,
            };
            setSize(size);

            doc.addEventListener('wheel', e => onWheel ? onWheel(e) : {});

            let pos: position | null = null;
            const body = doc.querySelector('body');
            assert(body !== null, 'body is null');
            body.addEventListener('mousedown', e => {
                pos = {
                    x: e.screenX,
                    y: e.screenY,
                };
            });
            body.addEventListener('mouseup', e => pos = null);
            body.addEventListener('mousemove', e => {
                if (pos) {
                    const [x, y] = [e.screenX, e.screenY];
                    onDrag({
                        x: (x - pos.x),
                        y: (y - pos.y),
                    });
                    pos = {x: e.screenX, y: e.screenY};
                }
            });
        }}
    />);
}
